module.exports = __webpack_public_path__ + "b616910a665fe0ecc12b78b3868a4fe1.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.html
// module id = 2640
// module chunks = 0